import React, { useEffect, useMemo, useRef, useState } from "react";
import './styles.css';
import axios from "axios";
import { Stock } from "../ItemList/types";
import useAppData from "@/store/useAppData";

export interface DeicingSummaryFilterDialogWindowProps {
    onCloseDialog?: () => void
    onConfirmDialog?: (selectedStock?: Stock) => void
}

const StockMoveExcelTechDeiceFilterDialogWindow: React.FC<DeicingSummaryFilterDialogWindowProps> = ({ onCloseDialog, onConfirmDialog }) => {

    const [stocksState, setStocksState] = React.useState<Stock[]>([]);
    const [selectedStockState, setSelectedStockState] = React.useState<Stock | null>(null);
    const selectedModule = useAppData(state => state.selectedModule);

    useEffect(() => {
        loadStocks();
    }, []);

    const loadStocks = async () => {

        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/stock/getAll",
                    data: {
                        module: selectedModule?.id
                    }
                })
            );

            setStocksState(res.data.stocks || []);

        } catch (err) {
            throw err;
        }
    }

    return <div className="deice-summary-dialog">
        <div className="deice-summary-dialog-content">
            <div className="deice-summary-dialog-title">
                Excel (Tech. odmraz)
            </div>

            <SelectField
                label="Vozidlo"
                value={selectedStockState?.id ?? ""}
                options={stocksState.filter(stock => !stock?.main)?.map(stock => ({ label: stock.name, value: stock.id }))}
                onChange={value => {
                    setSelectedStockState(value
                        ? stocksState.find(stock => Number(stock.id) === Number(value)) ?? null
                        : null);
                }}
            />
            <div className="deice-summary-dialog-buttons">
                <button
                    type="button"
                    className="deice-summary-dialog-close"
                    onClick={onCloseDialog}
                >
                    Zrušit
                </button>
                <button
                    type="button"
                    className="deice-summary-dialog-confirm"
                    onClick={() => onConfirmDialog?.(selectedStockState ?? undefined)}
                >
                    Export
                </button>
            </div>
        </div>
    </div>
};

interface Option {
    value: string;
    label: string;
}

interface SelectFieldProps {
    label: string;
    value: string | number | null | undefined;
    options: Option[];
    onChange: (value: string) => void;
    disabled?: boolean;
}

const SelectField: React.FC<SelectFieldProps> = ({
    label,
    value,
    options,
    onChange,
    disabled = false
}) => (
    <label>
        {label}
        <select
            value={value ?? undefined}
            onChange={event => onChange(event.target.value)}
            disabled={disabled}
        >
            <option value="">Vše</option>

            {options.map(option => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    </label>
);

export default StockMoveExcelTechDeiceFilterDialogWindow;
